import Stack from '@mui/material/Stack';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { Box, Container } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

import { useOffSetTop } from 'src/hooks/use-off-set-top';
import { useResponsive } from 'src/hooks/use-responsive';

import LogoMedicoreGrumeba from 'src/components/logo/logo-medicore-grumeba';

import { HEADER } from '../config-layout';
import HeaderShadow from './header-shadow';
import NavMobile from '../main/nav/mobile';
import NavDesktop from '../main/nav/desktop';
import SettingsButton from './settings-button';
import { navConfig } from '../main/config-navigation';

// ----------------------------------------------------------------------

export default function HeaderSimple() {
  const theme = useTheme();
  const offsetTop = useOffSetTop(HEADER.H_DESKTOP - 105);
  const mdUp = useResponsive('up', 'md');

  return (
    <AppBar
      sx={{
        backgroundColor: offsetTop 
          ? alpha(theme.palette.background.default, 0.95)
          : 'transparent',
        backdropFilter: offsetTop ? 'blur(8px)' : 'none',
        transition: theme.transitions.create(['background-color', 'backdrop-filter'], {
          easing: theme.transitions.easing.easeInOut,
          duration: theme.transitions.duration.shorter,
        }),
        paddingTop: 2,
        paddingBottom: 2,
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          height: {
            xs: HEADER.H_MOBILE,
            md: '100px',
          },
          transition: theme.transitions.create(['height'], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter,
          }),
          ...(offsetTop && {
            height: {
              xs: HEADER.H_MOBILE,
              md: '80px',
            },
          }),
        }}
      >
        <Container 
          maxWidth="xl"
          sx={{ 
            height: 1, 
            display: 'flex', 
            alignItems: 'center',
            px: { xs: 2, md: 2 },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              transition: theme.transitions.create(['transform'], {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.shorter,
              }),
              ...(offsetTop && {
                transform: 'scale(0.9)',
              }),
            }}
          >
           <LogoMedicoreGrumeba  lightMode={theme.palette.mode === 'light'} width={200} height={100} />
          </Box>

          <Box sx={{ flexGrow: 1 }} />

          <Stack 
            direction="row" 
            alignItems="center" 
            spacing={{ xs: 1, md: 2 }}
            sx={{ 
              flexShrink: 0,
            }}
          >
            {mdUp && (
              <NavDesktop 
                data={navConfig} 
                lightBackground={offsetTop}
                sx={{
                  mr: 2,
                }}
              />
            )}

            <SettingsButton
              lightBackground={!offsetTop}
              sx={{
                transition: theme.transitions.create(['transform'], {
                  easing: theme.transitions.easing.easeInOut,
                  duration: theme.transitions.duration.shorter,
                }),
                '&:hover': {
                  transform: 'scale(1.05)',
                },
              }}
            />

            {!mdUp && (
              <NavMobile 
                data={navConfig}
                sx={{
                  ml: 1,
                }}
              />
            )}
          </Stack>
        </Container>
      </Toolbar>

      {offsetTop && <HeaderShadow />}
    </AppBar>
  );
}
